import { HotelFormFields } from '../../../TravelMap/pages/Hotel/HotelForm.types';

export interface PlaceToStayFormFields
  extends Readonly<{
    address: string;
    customAddress: string;
    name: string;
    customName: string;
    link: string;
    customUrl: string;
    note: string;
    latitude: number | null;
    longitude: number | null;
    googlePlaceId: string | null;
    isCustomLinkEnabled: boolean;
    joyPlaceId: string | null;
    photoUrl: string | null;
    [key: string]: unknown;
  }> {}

export const convertToMutationFormat = (values: PlaceToStayFormFields): HotelFormFields => {
  const hotelFormFields: HotelFormFields = {
    address: values.address,
    customAddress: values.customAddress,
    name: values.name,
    customName: values.customName,
    url: values.link,
    customUrl: values.customUrl,
    note: values.note,
    latitude: values.latitude,
    longitude: values.longitude,
    googlePlaceId: values.googlePlaceId,
    joyPlaceId: values.joyPlaceId,
    photoUrl: values.photoUrl,
    isCustomLinkEnabled: values.isCustomLinkEnabled,
    zhId: null,
    isBookingLinkDisabled: true,
    bookingUrl: null,
    checkInDate: null,
    checkOutDate: null,
    cutoffDate: null,
    isJoyManagedRoomBlock: false,
    numberOfRoomsReserved: null,
    pricePerNight: null,
    strikeoutPricePerNight: null,
  };
  return hotelFormFields;
};
